import React, { useContext } from "react";
// import CloseIcon from "@mui/icons-material/Close";
import { Dialog, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { ThemeContext } from "../../theme/ThemeContext";
import CancelButtons from "../DialogBoxComponent/CancelButtons";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "20px",
    "&.MuiDialog-paper": {
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
    "&.MuiDialogTitle-root": {
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function BulkInvitationDialog(props) {
  const { darkMode } = props.darkMode;
  const classes = useStyles({ darkMode });
  const { onSubmit, children, onClose, ...other } = props;

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleClose = () => {
    props.onClose(false);
  };
  return (
    <>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        {...props}
        onClose={(event, reason) => {
          // Prevent closing the dialog on backdrop click or escape key
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return; // Prevent closing
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
            // Adjust the opacity as needed
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>
          {props.Header}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        {props.children}
        <DialogActions
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
            paddingRight: "16px",
          }}
        >
          <CancelButtons onClick={() => props.cancel()}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.cancelText}
            </Typography>
          </CancelButtons>

          <SubmitButtons onClick={onSubmit} type="submit">
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.acceptText}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
